import React, { useEffect, useState } from 'react';
import NoData from '../_common/NoData';
import { dataConstants } from '../../constants';
import { styled } from '@mui/material/styles';
import {
  Box, Button, Dialog,
  //  DialogActions,
  DialogContent, DialogTitle, Divider, Fade, IconButton, LinearProgress, ListItemIcon, Menu, MenuItem, Paper, Slide, Typography
} from '@mui/material';
import dynamic from 'next/dynamic';
import LoadingItem from '../_common/Skeleton/stock';
import { downloadCSV } from '../../utils/helpers';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import getUserWatchlist from '../../../lib/watchlist/_getUserWatchlist';
import deleteFromWatchlist from '../../../lib/watchlist/_deleteFromWatchlist';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
// import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
// import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import renameWatchlist from '../../../lib/watchlist/_renameWatchlist';
import addToWatchlist from '../../../lib/watchlist/_addToWatchlist';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import WatchlistTickerSearch from './TickerSearch';
// import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import RenameWatchlist from './RenameWatchlist';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import ManageColumnsDialog from './ManageTableColumns';
import WatchlistNote from './WatchlistNote';
import { useRouter } from 'next/router';
import * as send from '../../../lib/analytics/send';
import { needPremium } from '../../needPremium';

// const { DEFAULT_TBL_COLS } = dataConstants;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaginationTable = dynamic(() => import('./WatchlistTable'),
  { loading: () => <LoadingItem height={500} /> })

const { STOCK_SECTION_CODES } = dataConstants;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  position: 'relative',
  color: theme.palette.text.secondary,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .col-md-4:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#fbfbfc',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(2),
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.9rem',
    }
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const WatchlistTable = ({
  mainHeadCols,
  cols,
  row_metrics,
  // value,
  tickers,
  isPremium,
  openDialog,
  selectedWatchlist,
  selectedWatchlistDesc,
  selectedWatchlistNotes,
  accessToken,
  setStatus,
  getAllWatchlists,
  deleteWatchlist,
  disable,
  refresh,
  isSystemDefault,
  setColumnGroups,
  setColumns,
  onSortEnd,
  handleSaveColumns,
  tableName,
  showPricingBanner,
}) => {
  const router = useRouter();
  const [watchMetrics, setWatchMetrics] = useState([])
  const [loading, setLoading] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [tableCols, setTableCols] = React.useState(cols);
  // const [open, setOpen] = useState(false);
  const [_openDialog, setOpenDialog] = useState(false);
  // const [newWatchlist, setNewWatchlist] = useState(false);
  const [renameSuccess, setRenameSuccess] = useState(false);
  // const [nameSuccess, setnameSuccess] = useState(false);
  const [name, setName] = useState('');
  const [error, setError] = useState(false);
  const [invalidChar, setInvalidChar] = useState('');
  const [newTickers, setNewTickers] = useState([]);
  const [showSearch, setShowSearch] = useState(false)

  const handleTickerChange = (_newTickers) => { setNewTickers(_newTickers); };

  const handleTickersDialog = () => { setOpenDialog(true); setAnchorEl(null); };

  // const handleNewWatchlistDialog = () => { setNewWatchlist(true); setAnchorEl(null); };

  const handleDialogClose = () => { setOpenDialog(false); };

  const handleDeleteWatchlist = () => { deleteWatchlist(); setAnchorEl(null); };

  const handleMenuClick = (event) => { setAnchorEl(event.currentTarget); };

  const handleMenuClose = () => { setAnchorEl(null); };

  const handleUserWatchlist = async (tickers) => {
    if (tickers && tickers.length > 0) {
      setLoading(true);
      await getUserWatchlist(tickers)
        .then(data => {
          setWatchMetrics(data?.getWatchlistMetrics)
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching watchlist:', error);
          setLoading(false);
        });
    }
  }

  const handleDeleteWatchlistItem = async (watchlist = selectedWatchlist, ticker) => {
    setAnchorEl(null);
    setLoading(true);
    await deleteFromWatchlist(watchlist, ticker, accessToken)
      .then(data => {
        setStatus(data?.deleteFromWatchlist?.status)
        if (data?.deleteFromWatchlist?.status === "Success") {
          getAllWatchlists()
        }
        setLoading(false);
      })
      .catch(err => {
        console.log('caught it!', err);
        setLoading(false);
      });
  }

  const handleAddTicketsToWatchlist = async (watchlist, tickers, notes, description) => {
    setOpenDialog(false);
    const _tickers = tickers?.map(obj => obj.t)
    const _watchlist = watchlist === "" ? "My Watchlist" : watchlist
    const _notes = notes || ""
    const _description = description || ""
    const _columns = null
    setLoading(true);
    await addToWatchlist(_watchlist, _tickers, _notes, _description, _columns, accessToken)
      .then(data => {
        setStatus(data?.addToWatchlist?.status)
        if (data?.addToWatchlist?.status === "Success") {
          setShowSearch(false)
          getAllWatchlists()
        }
        setLoading(false);
      })
      .catch(err => {
        console.log('caught it!', err);
        setLoading(false);
      });
  }

  const handleRenameWatchlist = async (watchlist, new_list_name, description) => {
    setAnchorEl(null);
    setLoading(true)
    await renameWatchlist(watchlist, new_list_name, description, accessToken)
      .then(data => {
        setRenameSuccess(data?.renameWatchlist?.status)
        if (data?.renameWatchlist?.status === "Success") {
          if (watchlist !== new_list_name) {
            router?.push(`/watchlists/u/${new_list_name}`)
          }
          getAllWatchlists();
        }
        setLoading(false);
        // setRename(false);
      })
      .catch(err => {
        console.log('caught it!', err);
        setLoading(false);
        // setRename(false);
      });
  }

  const handleCopyWatchlist = async () => {
    setOpenDialog(false);
    if (selectedWatchlist && selectedWatchlist !== "") {
      const _tickers = tickers || []
      // const _tickers = tickers?.map(obj => obj.t)
      const _watchlist = selectedWatchlist ? `Copy of ${selectedWatchlist}` : ""
      const _notes = selectedWatchlistNotes || ""
      const _description = selectedWatchlistDesc || ""
      const _columns = JSON.stringify(cols?.filter(item => item !== null && item !== undefined)?.map(item => item?.field)).replace(/"/g, "'");
      setLoading(true);
      setAnchorEl(null);
      await addToWatchlist(_watchlist, _tickers, _notes, _description, _columns, accessToken)
        .then(data => {
          setStatus(data?.addToWatchlist?.status)
          if (data?.addToWatchlist?.status === "Success") {
            router?.push(`/watchlists/u/${_watchlist}`)
          }
          setLoading(false);
        })
        .catch(err => {
          console.log('caught it!', err);
          setLoading(false);
          throw new Error(err);
        });
    }
  }

  const handleDownload = (e) => {
    setAnchorEl(null);
    if (isPremium) {
      downloadCSV(
        row_metrics?.sort((a, b) => {
          return b?.MKTCAP - a?.MKTCAP;
        }),
        cols,
        `${selectedWatchlist}_Watchlist`,
        false,
        true
      );
      send.uevent(e)
    } else {
      // openDialog(e, "watchlist")
      showPricingBanner(e, "watchlist-download-csv")
    }
  };

  // const handleChange = (event) => {
  //   const inputValue = event.target.value;
  //   if (inputValue.length > 27) {
  //     setError(true);
  //     setInvalidChar('');
  //   } else {
  //     const invalid = inputValue.match(/[^a-zA-Z0-9_]/);
  //     if (invalid) {
  //       setError(true);
  //       setInvalidChar(invalid[0]);
  //     } else {
  //       setError(false);
  //       setInvalidChar('');
  //     }
  //   }
  //   setName(inputValue);
  // };

  const handleRefresh = () => {
    // getAllWatchlists(value)
    getAllWatchlists()
  }

  // useEffect(() => {
  //   handleUserWatchlist(tickers)
  // }, [tickers])

  // useEffect(() => {
  //   handleUserWatchlist(tickers)
  // }, [])

  return (
    // <NoData noData={!(realtime_stock_data || chartData)}>
    // <NoData noData={!(watchMetrics && watchMetrics?.length > 0)}>
    <div className="s-section fair-value-section">
      <div className="row mt-2">
        <div className="col-md-12">
          {<div className="peers-table">
            <div className="t-con-own">
              <Item className="s-card life-story-chart" sx={{ mt: 1.5 }} elevation={0}>
                <Box className="crisischart">
                  <Box
                    component="div"
                    // className="Item-Head"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: { md: 'center', sm: 'start', xs: 'start' },
                      justifyContent: 'end',
                      mb: 0.5,
                      px: 0.5,
                    }}
                  >
                    {/* <Typography component="h4" className="option-title" sx={{ mr: 2, mb: { md: 0, sm: 1, xs: 1 } }} >
                        {selectedWatchlist}
                      </Typography> */}
                    {/* <Button variant="outlined" size="small"
                        startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: '.8rem !important' }} />}
                        sx={{
                          px: 1, py: 0.5, lineHeight: 1, color: '#565b75',
                          background: '#fbfbfc !important',
                          border: '1px solid #dbdce4',
                          '&:hover': {
                            background: 'transparent !important',
                          },
                        }}
                        onClick={handleDownload}
                      >
                        CSV
                      </Button> */}
                    {/* <ManageColumnsDialog
                      arrayOrder={mainHeadCols}
                      columns={cols}
                      setColumnGroups={setColumnGroups}
                      setColumns={setColumns}
                      onSortEnd={onSortEnd}
                    /> */}
                    {/* <LightTooltip describeChild title="Refresh" placement="top" disableInteractive>
                      <IconButton disabled={disable} sx={{
                        '& .spin': {
                          animation: "spin 1s infinite", m: 'auto', transform: 'scaleX(-1)'
                        },
                        "@keyframes spin": {
                          "0%": {
                            transform: "rotate(0deg)"
                          },
                          "100%": {
                            transform: "rotate(360deg)"
                          }
                        }
                      }}>
                        <RefreshRoundedIcon className={refresh ? "spin" : ''} fontSize="inherit" onClick={handleRefresh} />
                      </IconButton>
                    </LightTooltip> */}
                    {/* <div>
                      <LightTooltip describeChild title="Menu" placement="top" disableInteractive>
                        <IconButton
                          disabled={disable}
                          id="fade-button"
                          aria-controls={openMenu ? 'fade-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={openMenu ? 'true' : undefined}
                          onClick={handleMenuClick}
                        >
                          <MoreVertIcon fontSize="inherit" />
                        </IconButton>
                      </LightTooltip>
                      <Menu
                        id="fade-menu"
                        MenuListProps={{
                          'aria-labelledby': 'fade-button',
                        }}
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                        TransitionComponent={Fade}
                      >
                        <MenuItem onClick={handleDownload}>
                          <ListItemIcon>
                            <DownloadRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Download as CSV
                          </Typography>
                        </MenuItem>
                        <MenuItem onClick={() => handleTickersDialog(true)} disabled={isSystemDefault}>
                          <ListItemIcon>
                            <AddRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Add Tickers
                          </Typography>
                        </MenuItem>
                        <RenameWatchlist selectedWatchlist={selectedWatchlist} handleRenameWatchlist={handleRenameWatchlist} isSystemDefault={isSystemDefault} />
                        {/* <ManageColumnsDialog arrayOrder={mainHeadCols} columns={cols} setColumnGroups={setColumnGroups} setColumns={setColumns} />  *}
                        <Divider />
                        <MenuItem onClick={handleDeleteWatchlist} disabled={isSystemDefault}>
                          <ListItemIcon>
                            <DeleteOutlineRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Delete "{selectedWatchlist}"
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </div> */}
                  </Box>
                  {/* <Divider /> */}
                  <Box component="div" className="option-content">
                    <Box component="div" className="watch-table" sx={{ '& .searchField': { right: 'auto !important', left: '0 !important' } }}>
                      {(loading || refresh) &&
                        <Box sx={{ zIndex: 999, position: 'absolute', top: 0, height: '100%', width: '100%', cursor: 'wait' }}>
                          <LinearProgress sx={{ bgcolor: "#9ea2ba96" }} />
                          <Box sx={{ height: '100%', background: 'rgba(0, 0, 0, 0.5)' }} />
                        </Box>}
                      {tickers && tickers?.length > 0 && row_metrics && row_metrics.length > 0 ?
                        // && watchMetrics && watchMetrics.length > 0 ?
                        <>
                          <PaginationTable
                            wrapperClass={'watch-table'}
                            shortWrapperClass={'watch-field'}
                            // headCells={cols}
                            fieldToSort={"MKTCAP"}
                            rows={row_metrics}
                            noOfRows={25}
                            quickSearch={true}
                            fullToolbarAccess={true}
                            createSections={false}
                            needToolbar={true}
                            mainHeadCols={mainHeadCols}
                            searchPosAbsolute={false}
                            isPremium={true}
                            watchlist={true}
                            handleDeleteWatchlistItem={handleDeleteWatchlistItem}
                            isSystemDefault={isSystemDefault}
                            headCells={tableCols}
                            setTableCols={setTableCols}
                            defaultHeadCells={cols}
                            enableColSort={true}
                            tableName={tableName}
                            handleSaveColumns={handleSaveColumns}
                            manageColumns={
                              <ManageColumnsDialog
                                arrayOrder={mainHeadCols}
                                columns={cols}
                                setColumnGroups={setColumnGroups}
                                setColumns={setColumns}
                                onSortEnd={onSortEnd}
                                handleSaveColumns={handleSaveColumns}
                              />}
                            refreshTable={
                              <LightTooltip describeChild title="Refresh" placement="top" disableInteractive>
                                <IconButton
                                  onClick={handleRefresh}
                                  disabled={disable}
                                  sx={{
                                    ml: 1,
                                    '& .spin': {
                                      animation: "spin 1s infinite", m: 'auto', transform: 'scaleX(-1)'
                                    },
                                    "@keyframes spin": {
                                      "0%": {
                                        transform: "rotate(0deg)"
                                      },
                                      "100%": {
                                        transform: "rotate(360deg)"
                                      }
                                    }
                                  }}>
                                  <RefreshRoundedIcon className={refresh ? "spin" : ''} fontSize="small" sx={{ color: '#434166' }} />
                                </IconButton>
                              </LightTooltip>}
                            download={
                              <LightTooltip describeChild title="Download as CSV" placement="top" disableInteractive>
                                <IconButton disabled={!row_metrics || row_metrics.length === 0} onClick={handleDownload}
                                  data-event-name="download" data-event-category={`watchlist`} data-event-label={`${selectedWatchlist}-csv`}
                                >
                                  <DownloadRoundedIcon fontSize="small" sx={{ color: row_metrics.length === 0 ? 'rgba(0, 0, 0, 0.26)' : '#434166', pointerEvents: 'none' }} />
                                </IconButton>
                              </LightTooltip>}
                            addTicker={
                              <Button
                                disableElevation
                                sx={{ textTransform: 'none', ml: 'auto', lineHeight: 1, background: 'rgb(236 235 241)', border: '1px solid rgb(236 235 241) !important' }}
                                variant="outlined"
                                startIcon={<AddRoundedIcon fontSize="small" />}
                                size="small"
                                onClick={() => handleTickersDialog(true)}
                                disabled={isSystemDefault}
                              >
                                Add Tickers
                              </Button>}
                            menu={
                              <div>
                                <LightTooltip describeChild title="Menu" placement="top" disableInteractive>
                                  <IconButton
                                    disabled={disable}
                                    id="fade-button"
                                    aria-controls={openMenu ? 'fade-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openMenu ? 'true' : undefined}
                                    onClick={handleMenuClick}
                                  >
                                    <MoreVertIcon fontSize="small" />
                                  </IconButton>
                                </LightTooltip>
                                <Menu
                                  id="fade-menu"
                                  MenuListProps={{
                                    'aria-labelledby': 'fade-button',
                                  }}
                                  anchorEl={anchorEl}
                                  open={openMenu}
                                  onClose={handleMenuClose}
                                  TransitionComponent={Fade}
                                >
                                  <MenuItem onClick={handleCopyWatchlist} disabled={isSystemDefault}>
                                    <ListItemIcon>
                                      <ContentCopyRoundedIcon fontSize="small" />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap fontSize="small" >
                                      Copy watchlist
                                    </Typography>
                                  </MenuItem>
                                  {/* <MenuItem onClick={handleDownload}>
                                <ListItemIcon>
                                  <DownloadRoundedIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit" noWrap fontSize="small" >
                                  Download as CSV
                                </Typography>
                              </MenuItem> */}
                                  {/* <MenuItem onClick={() => handleTickersDialog(true)} disabled={isSystemDefault}>
                                <ListItemIcon>
                                  <AddRoundedIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit" noWrap fontSize="small" >
                                  Add Tickers
                                </Typography>
                              </MenuItem> */}
                                  <RenameWatchlist
                                    selectedWatchlist={selectedWatchlist}
                                    selectedWatchlistDesc={selectedWatchlistDesc}
                                    handleRenameWatchlist={handleRenameWatchlist}
                                    isSystemDefault={isSystemDefault}
                                  />
                                  {/* <ManageColumnsDialog arrayOrder={mainHeadCols} columns={cols} setColumnGroups={setColumnGroups} setColumns={setColumns} /> */}
                                  <Divider />
                                  <MenuItem onClick={handleDeleteWatchlist} disabled={isSystemDefault}>
                                    <ListItemIcon>
                                      <DeleteRoundedIcon fontSize="small" />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap fontSize="small" >
                                      {/* Delete "{selectedWatchlist}" */}
                                      Delete
                                    </Typography>
                                  </MenuItem>
                                </Menu>
                              </div>}
                          />
                          <Box component="div" sx={{ mt: 2, mb: 27, position: 'relative', }}>
                            <WatchlistNote
                              selectedWatchlistNotes={selectedWatchlistNotes}
                              selectedWatchlistDesc={selectedWatchlistDesc}
                              selectedWatchlist={selectedWatchlist}
                              accessToken={accessToken}
                              tickers={tickers}
                              isSystemDefault={isSystemDefault}
                            />
                          </Box>
                        </>
                        :
                        <Box component="div" sx={{ border: 1, borderColor: 'hsla(216, 41%, 87%, 0.8)', borderRadius: '7px' }}>
                          {refresh ? null :
                            <Box component="div" sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', pt: 1.5, pb: 1, background: '#fbfbfc', borderRadius: '7px 7px 0 0' }}>
                              {tableName}
                              <div>
                                <LightTooltip describeChild title="Menu" placement="top" disableInteractive>
                                  <IconButton
                                    disabled={disable}
                                    id="fade-button"
                                    aria-controls={openMenu ? 'fade-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openMenu ? 'true' : undefined}
                                    onClick={handleMenuClick}
                                  >
                                    <MoreVertIcon fontSize="small" />
                                  </IconButton>
                                </LightTooltip>
                                <Menu
                                  id="fade-menu"
                                  MenuListProps={{
                                    'aria-labelledby': 'fade-button',
                                  }}
                                  anchorEl={anchorEl}
                                  open={openMenu}
                                  onClose={handleMenuClose}
                                  TransitionComponent={Fade}
                                >
                                  <MenuItem onClick={handleCopyWatchlist} disabled={isSystemDefault}>
                                    <ListItemIcon>
                                      <ContentCopyRoundedIcon fontSize="small" />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap fontSize="small" >
                                      Copy watchlist
                                    </Typography>
                                  </MenuItem>
                                  <RenameWatchlist
                                    selectedWatchlist={selectedWatchlist}
                                    selectedWatchlistDesc={selectedWatchlistDesc}
                                    handleRenameWatchlist={handleRenameWatchlist}
                                    isSystemDefault={isSystemDefault}
                                  />
                                  {/* <Divider /> */}
                                  <MenuItem onClick={handleDeleteWatchlist} disabled={isSystemDefault}>
                                    <ListItemIcon>
                                      <DeleteRoundedIcon fontSize="small" />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap fontSize="small" >
                                      {/* Delete "{selectedWatchlist}" */}
                                      Delete
                                    </Typography>
                                  </MenuItem>
                                </Menu>
                              </div>
                            </Box>}
                          <Divider sx={{ borderColor: 'hsla(216, 41%, 87%, 0.8)', }} />
                          <Box component="div" sx={{ height: '50vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                            <Typography variant="h6" sx={{ my: 2, fontSize: '1.1rem' }}>Nothing in this watchlist yet</Typography>
                            <Typography variant="body2" color="rgb(128,134,139)">Keep track of all your investments here!</Typography>
                            <Button size="small"
                              variant='outlined'
                              sx={{ mt: 4, mx: 2, textTransform: 'none', background: 'rgb(236 235 241)', border: '1px solid rgb(236 235 241) !important' }}
                              startIcon={<AddRoundedIcon />} onClick={() => handleTickersDialog(true)}
                            >
                              Add Tickers
                            </Button>
                          </Box>
                        </Box>}
                    </Box>
                  </Box>
                </Box>
              </Item>
            </div>
          </div>}
        </div>
      </div>
      <Dialog
        open={_openDialog}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="xs"
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        onSubmit={(e) => { e.preventDefault(); handleAddTicketsToWatchlist(selectedWatchlist, newTickers) }}
      >
        <DialogTitle>{`Add tickers to ${selectedWatchlist}`}</DialogTitle>
        <DialogContent>
          <Box
            // component="form"
            sx={{
              '& .MuiTextField-root': { width: '100%' },
            }}
            noValidate
            autoComplete="off"
          // onSubmit={(e) => { e.preventDefault(); handleAddTicketsToWatchlist(selectedWatchlist, newTickers); }}
          >
            <WatchlistTickerSearch
              selectedWatchlist={selectedWatchlist}
              // setShowSearch={setShowSearch}
              removebackdrop={false}
              handleTickerChange={handleTickerChange}
              tickers={newTickers}
            />
            {/* <DialogActions sx={{ mb: 1, pt: 0 }}> */}
            <Box component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', mt: 3 }}>
              <Button size="small" sx={{ textTransform: 'none', ml: 'auto' }} onClick={handleDialogClose}>Cancel</Button>
              <Button
                type="submit"
                size="small"
                variant="contained"
                sx={{ textTransform: 'none', ml: 1 }}
                onClick={() => handleAddTicketsToWatchlist(selectedWatchlist, newTickers)}
                disabled={newTickers && newTickers.length === 0}
              >
                Add Tickers
              </Button>
            </Box>
            {/* </DialogActions> */}
          </Box>
        </DialogContent>
      </Dialog>
    </div>
    // </NoData >
  );
}

export default needPremium(WatchlistTable)
